module.exports = __webpack_public_path__ + "c1defdd6ebfd3bd1.otf";